import "./save-on-exit-modal.css";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const SaveChangesModal = ({
	onStay,
	onDiscardAndLeave,
	onSaveAndLeave,
	isOpen,
	isSaving,
	rerateRequired,
}: {
	onStay: () => void;
	onDiscardAndLeave: () => void;
	onSaveAndLeave: () => void;
	isOpen: boolean;
	isSaving: boolean;
	rerateRequired: boolean;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			canLeave={true}
			canLeaveText={
				rerateRequired ? "Leave without Saving" : "Leave without saving"
			}
			cancelText={"Keep Editing"}
			className={rerateRequired ? "rerate-save-changes-modal" : undefined}
			confirmDisabled={isSaving}
			confirmText={rerateRequired ? "Save & Rerate" : "Save & Exit"}
			onCanLeave={onDiscardAndLeave}
			onCancel={onStay}
			onClose={onStay}
			onConfirm={onSaveAndLeave}
			showButtonsDisabled={isSaving}
			showConfirmationButtons={true}
			title={
				rerateRequired ? "Rerate to Save Changes" : "Changes Won't Be Saved"
			}
			type={rerateRequired ? "confirmation" : "error"}
			width={rerateRequired ? 394 : "30%"}
		>
			<div>
				{rerateRequired ? (
					<>
						If you leave now, all changes will be lost. Select &ldquo;Save &amp;
						Rerate&rdquo; to save your changes, or &ldquo;Keep Editing&rdquo; to
						make additional updates.
					</>
				) : (
					<>
						If you leave now, all changes will be lost. Select &quot;Save &amp;
						Exit&quot; to save your changes, or &quot;Keep Editing&quot; to make
						additional updates.
					</>
				)}
			</div>
		</TraxModal>
	);
};
